export default "__VITE_ASSET__helO4u$S__"